import React from 'react';
import styles from "./PreenchaDados.css";
import Header from "../../components/features/login/Header";
import TitleModule from '../../components/features/register/TitleModule';
import RegisterProgress from '../../components/features/register/RegisterProgress';
import Preencher from "../../components/Termo/Preencher";

const TermoCooperacaoPage = () => {
    return (
      <div className="PreenchaDados-Page"> 
        <Header/>
        <div className={styles.container}>
            <TitleModule/>
            <RegisterProgress step={4} title="Termo de cooperação" icon="Assignment"/>
            <Preencher/>
        </div>
      </div>
    );
  };
  
  export default TermoCooperacaoPage;
  